import React, { Component } from "react";
import MyNavbar from "../../../components/Navbar/MyNavbar";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { Form, FormField, TextBox, ComboBox, Panel } from "rc-easyui";
import "./UserGroupPage.css";
import {
  control_panel_modules,
  control_panel_reports,
} from "../../../constants/index";
import { Button } from "reactstrap";
import setTitle from "../../../helpers/TitleComponent";
import { API_URL, BASE_URL } from "../../../constants";

const axios = require("axios");

export default class UserGroupPage extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.state = {
      user: {
        name: null,
        description: null,
        enabled: true,
      },
      enabled: [
        { value: true, text: "Active" },
        { value: false, text: "Inactive" },
      ],
      rules: {
        name: ["required"],
        description: ['required']
      },
      modulesArray: [],
      errors: {},
      isLoading: false,
      setId: null,
      permissions: [],
    };
  }

  componentDidMount() {
    var data = getCookie("permission");
    let url_string = window.location.href;
    let url = new URL(url_string);
    let id = url.searchParams.get("id");
    if (id) {
      setTitle("Edit User Group");
      this.fetchData(id);
      this.setState({ setId: id, permissions: JSON.parse(data) }, function () {
        let items = document.getElementsByName("modules[]");
        items.forEach((elem) => {
          elem.addEventListener("change", function (e) {
            e.stopPropagation();
            if (this.checked) {
              let allcheck = true;
              for (let i = 0; i < items.length; i++) {
                if (
                  items[i].type === "checkbox" &&
                  items[i].checked === false
                ) {
                  allcheck = false;
                }
                //console.log("allcheck", allcheck);
                if (i === items.length - 1 && allcheck) {
                  document.getElementById("all").checked = true;
                  //console.log("if rkgregmekge");
                }
              }
            } else {
              document.getElementById("all").checked = false;
            }
          });
        });
      });
    } else {
      setTitle("Create User Group");
      this.setState({ permissions: JSON.parse(data) }, function () {
        let items = document.getElementsByName("modules[]");
        items.forEach((elem) => {
          elem.addEventListener("change", function (e) {
            e.stopPropagation();
            if (this.checked) {
              let allcheck = true;
              for (let i = 0; i < items.length; i++) {
                if (
                  items[i].type === "checkbox" &&
                  items[i].checked === false
                ) {
                  allcheck = false;
                }
                //console.log("allcheck", allcheck);
                if (i === items.length - 1 && allcheck) {
                  document.getElementById("all").checked = true;
                  //console.log("if rkgregmekge");
                }
              }
            } else {
              document.getElementById("all").checked = false;
            }
          });
        });
      });
    }
  }

  async fetchData(id) {
    this.setState({
      isLoading: true,
    });
    let token = getCookie("access_token");
    if (JSON.stringify(token) === "null") {
      const resp = await getAccessToken();
      if (resp) {
        this.getRoleData(id);
      }
    } else {
      this.getRoleData(id);
    }
  }

  getRoleData(id) {
    let tokenType = getCookie("token_type");
    let token = getCookie("access_token");
    let apiUrl = `${API_URL}api/role/${id}`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    let self = this;
    axios
      .get(apiUrl, headersConfig)
      .then(function (response) {
        console.log(response);
        if (response.status === 200) {
          if (response.data !== "") {
            if (response.data.status === true) {
              self.setState({
                user: response.data.object,
                isLoading: false,
              });
              let permissions = response.data.object.permissions;
              for (let i = 0; i < permissions.length; i++) {
                document.getElementById(
                  `${permissions[i].name}`
                ).checked = true;
              }
            } else {
              self.setState({
                isLoading: false,
                user: null,
              });
              alert(`${response.data.message}`);
            }
          } else {
            self.setState({
              isLoading: false,
            });
            // alert("Internal Server Error.");
          }
        } else {
          self.setState({
            isLoading: false,
          });
          // alert("Internal Server Error.");
        }
      })
      .catch(function (error) {
        console.log("error", error);
        let response = error["response"];

        if (response !== undefined) {
          if (response.status === 400) {
            var message = "";
            response.data.errors.forEach((row, i) => {
              message +=
                "<p style='margin-bottom:3px;'>" + row.defaultMessage + "</p>";
            });
            alert(message);
          } else {
            alert("Uncaught Error");
          }
        } else {
          alert("Internal Server Error");
        }
        self.setState({
          isLoading: false,
        });
      });
  }

  handleChange(name, value) {
    //console.log(name, value);
    let user = Object.assign({}, this.state.user);
    user[name] = value;
    this.setState({ user: user });
  }

  handleCheckAll() {
    let items = document.getElementsByName("modules[]");
    if (document.getElementById("all").checked) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].type === "checkbox") items[i].checked = true;
      }
    } else {
      for (let i = 0; i < items.length; i++) {
        if (items[i].type === "checkbox") items[i].checked = false;
      }
    }
  }

  handleRowCheckAll(id) {
    let tble = document.getElementById(id);
    let checkboxes = tble.querySelectorAll('input[type="checkbox"]');
    let val = checkboxes[0].checked;
    for (let i = 0; i < checkboxes.length; i++) checkboxes[i].checked = val;
  }

  handleSelectedCheckbox(tbleID) {
    let tabler = document.getElementById(tbleID);
    let val = tabler.cells[2].children[0].checked;
    for (let i = 2; i < 5; i++) tabler.cells[i].children[0].checked = val;
  }

  renderAccessModule() {
    let tableRows = [];
    let i = 1;
    for (let module in control_panel_modules) {
      tableRows.push(
        <tr id={i}>
          <td>{i}</td>
          <td>
            <input
              type='checkbox'
              className='checkbox-this-row check-all-this-row'
              name='modules[]'
              id={`checkbox-select-row-${i}`}
              value={`checkbox-select-row-${i}`}
              onChange={this.handleRowCheckAll.bind(this, i)}
            />
          </td>
          <td colSpan={control_panel_modules[module] === 'Reset Password' ? 4 : 0}>
            <input
              type='checkbox'
              className='check-create-read-only'
              name='modules[]'
              id={module}
              value={module}
              onChange={this.handleSelectedCheckbox.bind(this, i)}
            />{" "}
            {control_panel_modules[module]}
          </td>
          {control_panel_modules[module] === 'Reset Password' ? null :
            (<>
              <td>
                <input
                  type='checkbox'
                  className=' '
                  name='modules[]'
                  id={`${module}-create`}
                  value={`${module}-create`}
                />{" "}
                Create
              </td>
              <td>
                <input
                  type='checkbox'
                  className=' '
                  name='modules[]'
                  id={`${module}-view`}
                  value={`${module}-view`}
                />{" "}
                View
              </td>
              <td>
                <input
                  type='checkbox'
                  className=' '
                  name='modules[]'
                  id={`${module}-edit`}
                  value={`${module}-edit`}
                />{" "}
                Edit
              </td>
              <td>
                <input
                  type='checkbox'
                  className=' '
                  name='modules[]'
                  id={`${module}-delete`}
                  value={`${module}-delete`}
                />{" "}
                Delete
              </td></>)
          }
        </tr>
      );
      i++;
    }
    return tableRows;
  }

  renderReportModule() {
    let tableRowsReport = [];
    let i = 1;

    for (let module in control_panel_reports) {
      tableRowsReport.push(
        <tr id={`key${i}`}>
          <td>{i++}</td>
          <td>
            <input
              type='checkbox'
              className='check-create-read-only'
              name='modules[]'
              id={module}
              value={module}
            />{" "}
            {control_panel_reports[module]}
          </td>
        </tr>
      );
    }

    return tableRowsReport;
  }

  saveUserRole() {
    let tokenType = getCookie("token_type");
    let token = getCookie("access_token");
    let modulesArray = [];
    let roleData = this.state.user;
    let checkboxes = document.querySelectorAll("input[type=checkbox]:checked");
    for (let i = 0; i < checkboxes.length; i++) {
      if (
        !checkboxes[i].value.includes("checkbox-select-row-") &&
        checkboxes[i].value !== "on"
      ) {
        modulesArray.push(checkboxes[i].value);
      }
    }
    roleData.permissions = modulesArray;
    this.setState({ user: roleData });
    this.form.validate((errors) => {
      if (errors) {
        this.setState({
          isLoading: false,
        });
        alert("Field with * are required");
      } else {
        let headersConfig = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${tokenType} ${token}`,
          },
        };
        let self = this;
        let apiUrl = "";
        if (this.state.setId) {
          apiUrl = `${API_URL}api/role/${this.state.setId}`;
          axios
            .put(apiUrl, roleData, headersConfig)
            .then(function (response) {

              if (response.status === 200) {
                if (response.data !== "") {
                  if (response.data.status === true) {
                    self.setState({
                      isLoading: false,
                    });
                    window.location = `${BASE_URL}view-user-group`;
                  } else {
                    self.setState({
                      isLoading: false,
                    });
                    alert(`${response.data.message}`);
                  }
                } else {
                  this.setState({
                    isLoading: false,
                  });
                  alert("Internal Server Error.");
                }
              } else {
                this.setState({
                  isLoading: false,
                });
                alert("Internal Server Error.");
              }
            })
            .catch(function (error) {
              let response = error["response"];

              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.defaultMessage +
                      "</p>";
                  });
                  alert(message);
                } else {
                  alert("Uncaught Error");
                }
              } else {
                alert("Internal Server Error");
              }
              self.setState({
                isLoading: false,
              });
            });
        } else {
          apiUrl = `${API_URL}api/roles`;
          axios
            .post(apiUrl, roleData, headersConfig)
            .then(function (response) {

              self.handleResponse(response);
            })
            .catch(function (error) {


              let response = error["response"];

              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.defaultMessage +
                      "</p>";
                  });
                  alert(message);
                } else {
                  alert("Uncaught Error");
                }
              } else {
                alert("Internal Server Error");
              }
              self.setState({
                isLoading: false,
              });
            });
        }
      }
    });
  }

  async handleSubmit() {
    this.setState({
      isLoading: true,
    });
    let token = getCookie("access_token");
    if (JSON.stringify(token) === "null") {
      const resp = await getAccessToken();
      if (resp) {
        this.saveUserRole();
      }
    } else {
      this.saveUserRole();
    }
  }

  handleResponse(response) {
    if (response.status === 200) {
      if (response.data !== "") {
        if (response.data.status === true) {
          let items = document.getElementsByName("modules[]");
          for (let i = 0; i < items.length; i++) {
            if (items[i].type === "checkbox") items[i].checked = false;
          }
          this.setState({
            user: {},
            modulesArray: [],
            isLoading: false,
          });
          alert(`${response.data.message}`);
          //alert("Data saved successfully");
        } else if (response.data.status === false) {
          this.setState({
            isLoading: false,
          });
          alert(`${response.data.message}`);
        } else {
          this.setState({
            isLoading: false,
          });
          alert("Internal Server Error.");
        }
      } else {
        this.setState({
          isLoading: false,
        });
        alert("Internal Server Error.");
      }
    }
  }

  handleCancel() {
    if (this.state.setId) {
      window.location = "/view-user-group";
    } else {
      let items = document.getElementsByName("modules[]");
      for (let i = 0; i < items.length; i++) {
        if (items[i].type === "checkbox") items[i].checked = false;
      }
      this.setState({
        user: {},
        modulesArray: [],
      });
    }
  }

  render() {
    const { user, enabled, rules, isLoading, setId, permissions } = this.state;
    return (
      <div>
        <MyNavbar />
        {permissions.includes(
          setId ? "create-user-group-edit" : "create-user-group-create"
        ) ? (
          <div className='container-fluid' style={{ marginTop: "10px" }}>
            <div
              className='loadingmodel'
              style={{ display: isLoading ? "block" : "none" }}
            ></div>
            <div className='row'>
              <div className='col-12'>
                <Panel
                  title={setId ? "Edit User Role" : "Create User Role"}
                  bodyStyle={{ padding: 20 }}
                // style={{ height: 200 }}
                >
                  <Form
                    ref={(ref) => (this.form = ref)}
                    model={user}
                    labelWidth={120}
                    labelAlign='left'
                    rules={rules}
                    errorType='tooltip'
                    onChange={this.handleChange.bind(this)}
                    onValidate={(errors) => this.setState({ errors: errors })}
                  >
                    <p style={{ color: "red" }}>
                      Fields with * marks are mandatory fields{" "}
                    </p>
                    <FormField
                      className='requiredfield'
                      name='name'
                      label='Role Name:'
                    >
                      <TextBox value={user.name}></TextBox>
                    </FormField>
                    <FormField className='requiredfield' name='description' label='Description:'>
                      <TextBox value={user.description}></TextBox>
                    </FormField>
                    <FormField name='enabled' label='Select Status'>
                      <ComboBox
                        data={enabled}
                        valueField='value'
                        textField='text'
                        value={user.enabled}
                        editable={false}
                        style={{ marginRight: 800 }}
                      ></ComboBox>
                    </FormField>
                    <FormField name='accessModules' label='Access Modules'>
                      <div className='row'>
                        <div className='col-12 accesss-modules'>
                          <table className='table table-sm table-striped table-hover table-bordered'>
                            <thead>
                              <tr>
                                <th>Sr_no.</th>
                                <th>
                                  <input
                                    type='checkbox'
                                    className=''
                                    id='all'
                                    name='moduless[]'
                                    onChange={this.handleCheckAll.bind()}
                                  />{" "}
                                  All
                                </th>
                                <th>Modules</th>
                                <th colSpan='5'>Action Modules</th>
                              </tr>
                            </thead>

                            <tbody>{this.renderAccessModule()}</tbody>
                          </table>
                        </div>
                      </div>
                    </FormField>
                    <FormField
                      name='accessReportsModules'
                      label='Report Modules'
                    >
                      <div className='row'>
                        <div className='col-12 report-modules'>
                          <table className='table table-sm table-striped table-hover table-bordered'>
                            <thead>
                              <tr>
                                <th>Sr_no.</th>
                                <th>Reports</th>
                              </tr>
                            </thead>

                            <tbody>{this.renderReportModule()}</tbody>
                          </table>
                        </div>
                      </div>
                    </FormField>
                    <Button
                      color='primary'
                      onClick={this.handleSubmit}
                      style={{ marginLeft: 550, marginRight: 20 }}
                    >
                      Save
                    </Button>
                    <Button color='danger' onClick={this.handleCancel}>
                      Cancel
                    </Button>
                  </Form>
                </Panel>
              </div>
            </div>
          </div>
        ) : (
          <div>You are not allowed to access this module.</div>
        )}
      </div>
    );
  }

  //  var a = {
  //   "clientbasicinfo": {
  //     "organizationname": "abc",
  //     "provience": "state 5",
  //     "city": "butwal",
  //     "wardno": "5",
  //     "addressone": "butwal",
  //     "addresstwo": "kalikanagar",
  //     "phoneno": "1234567890",
  //     "altphone": "23456",
  //     "altphonetwo": "789545",
  //     "weburl": "www.dhamaladairy.com",
  //     "contactpersonname": "naresh dhamala",
  //     "mobileno": "789456987",
  //     "altmobile": "4567890",
  //     "emailaddress": "dhamaladairy@gmail.com",
  //     "panvatnumber": "789546",
  //     "createdby": "bimal",
  //     "renewcharge": 4500,
  //     "installationcharge": 50000
  //   },
  //   "clientaccessinfo": {
  //     "allowedsystemusers": 3,
  //     "priceplanid": 3,
  //     "allowedplatfroms": "Web",
  //     "allowedmodules": "accounting,dairy,system,reports,trading",
  //     "systemuserpermissions": ["user-group", "user-group-create", "user-group-view", "user-group-edit", "user-group-delete", "price-plan", "price-plan-create", "price-plan-view", "price-plan-edit", "price-plan-delete", "active-maintainance-mode", "active-maintainance-mode-create", "active-maintainance-mode-view", "active-maintainance-mode-edit", "active-maintainance-mode-delete", "client-registration", "client-registration-create", "client-registration-view", "client-registration-edit", "client-registration-delete"],
  //     "startdate": "2020-05-26",
  //     "expirydate": "2021-05-26"
  //   },
  // }
}
